export const chatData = {
  greeting: {
    message: "👋 Hello! Welcome to Learn Thru Us Academy. I'm your virtual assistant. How can I help you today?",
    options: ["📚 Courses & Programs", "💰 Fee Structure", "📅 Batch Schedule", "📞 Contact Support", "💬 Talk to Human"]
  },

  responses: {
    "📚 Courses & Programs": {
      message: "We offer world-class medical coding and healthcare programs:\n\nChoose a category to explore:",
      options: ["🏥 Medical Coding", "📋 CDI Training", "🎗️ Cancer Registry", "🔧 Specialized Training", "← Back to Main"]
    },
    "🏥 Medical Coding": {
      message: "Our Medical Coding programs include:",
      options: ["ICD-10-CM", "ICD-10-PCS", "CPT & E/M", "Exam Prep", "← Back to Courses"]
    },
    "ICD-10-CM": {
      message: "📘 ICD-10-CM Diagnosis Coding\n\n• 80 hours of comprehensive training\n• Hands-on practice with real scenarios\n• Includes all study materials\n• Course Fee: ₹25,000 / $299\n• 98% certification pass rate",
      options: ["✍️ Enroll Now", "📥 Download Syllabus", "👨‍💼 Talk to Advisor", "← Back to Medical Coding"]
    },
    "ICD-10-PCS": {
      message: "📗 ICD-10-PCS Procedure Coding\n\n• 60 hours of intensive training\n• Inpatient coding focus\n• 31 root operations mastery\n• Course Fee: ₹22,000 / $279\n• Practical exercises included",
      options: ["✍️ Enroll Now", "📥 Download Syllabus", "👨‍💼 Talk to Advisor", "← Back to Medical Coding"]
    },
    "CPT & E/M": {
      message: "📙 CPT & E/M Coding\n\n• 50 hours of detailed training\n• Evaluation & Management coding\n• Surgery coding mastery\n• Course Fee: ₹20,000 / $249\n• Real-world case studies",
      options: ["✍️ Enroll Now", "📥 Download Syllabus", "👨‍💼 Talk to Advisor", "← Back to Medical Coding"]
    },
    "Exam Prep": {
      message: "📕 Exam Preparation Courses\n\n• CCS Prep - ₹15,000 / $199\n• CPC Prep - ₹15,000 / $199\n• CIC Prep - ₹18,000 / $229\n\nAll include mock tests & practice questions!",
      options: ["CCS Prep", "CPC Prep", "CIC Prep", "← Back to Medical Coding"]
    },
    "CCS Prep": {
      message: "🎯 CCS Exam Preparation\n\n• 40 hours focused training\n• 500+ practice questions\n• Mock exams with timer\n• AHIMA exam pattern\n• Course Fee: ₹15,000 / $199",
      options: ["✍️ Enroll Now", "👨‍💼 Talk to Advisor", "← Back to Exam Prep"]
    },
    "CPC Prep": {
      message: "🎯 CPC Exam Preparation\n\n• 40 hours focused training\n• 500+ practice questions\n• Mock exams with timer\n• AAPC exam pattern\n• Course Fee: ₹15,000 / $199",
      options: ["✍️ Enroll Now", "👨‍💼 Talk to Advisor", "← Back to Exam Prep"]
    },
    "CIC Prep": {
      message: "🎯 CIC Exam Preparation\n\n• 35 hours focused training\n• 400+ practice questions\n• Mock exams with timer\n• Course Fee: ₹18,000 / $229",
      options: ["✍️ Enroll Now", "👨‍💼 Talk to Advisor", "← Back to Exam Prep"]
    },
    
    "📋 CDI Training": {
      message: "📋 Clinical Documentation Improvement Training\n\n• 60 hours comprehensive training\n• CDI certification prep (CCDS/CDIP)\n• Query writing practice\n• Course Fee: ₹28,000 / $349\n• Taught by India's first AHIMA Approved CDI Trainer",
      options: ["✍️ Enroll Now", "👨‍💼 Talk to Advisor", "← Back to Courses"]
    },
    
    "🎗️ Cancer Registry": {
      message: "🎗️ Cancer Registry / ODS Training\n\n• 80 hours training\n• NCRA exam preparation\n• Cancer staging & coding\n• Course Fee: ₹30,000 / $399",
      options: ["ODS Training", "Cancer Registry Management", "← Back to Courses"]
    },
    "ODS Training": {
      message: "🎗️ Oncology Data Specialist (ODS)\n\n• Comprehensive cancer registry training\n• 94% certification pass rate\n• Job placement assistance\n• Course Fee: ₹35,000 / $449",
      options: ["✍️ Enroll Now", "📥 Download Brochure", "👨‍💼 Talk to Advisor", "← Back to Cancer Registry"]
    },
    "Cancer Registry Management": {
      message: "📊 Cancer Registry Management\n\n• Registry operations & standards\n• Data quality & analysis\n• CoC & SEER requirements\n• Course Fee: ₹30,000 / $399",
      options: ["✍️ Enroll Now", "👨‍💼 Talk to Advisor", "← Back to Cancer Registry"]
    },
    
    "🔧 Specialized Training": {
      message: "🔧 Specialized Training Programs:",
      options: ["HCC/Risk Adjustment", "Inpatient DRG Coding", "Auditing Training", "← Back to Courses"]
    },
    "HCC/Risk Adjustment": {
      message: "📊 HCC/Risk Adjustment Training\n\n• 40 hours training\n• RAF scores & CMS-HCC model\n• Medicare Advantage focus\n• Course Fee: ₹18,000 / $229",
      options: ["✍️ Enroll Now", "👨‍💼 Talk to Advisor", "← Back to Specialized Training"]
    },
    "Inpatient DRG Coding": {
      message: "🏥 Inpatient DRG Coding\n\n• 50 hours training\n• MS-DRG methodologies\n• POA indicators & compliance\n• Course Fee: ₹25,000 / $299",
      options: ["✍️ Enroll Now", "👨‍💼 Talk to Advisor", "← Back to Specialized Training"]
    },
    "Auditing Training": {
      message: "🔍 Professional Medical Auditing\n\n• 45 hours training\n• CPMA certification prep\n• Compliance & regulations\n• Course Fee: ₹22,000 / $279",
      options: ["✍️ Enroll Now", "👨‍💼 Talk to Advisor", "← Back to Specialized Training"]
    },
    
    "💰 Fee Structure": {
      message: "💰 Our courses range from ₹15,000 to ₹35,000.\n\nFlexible payment options:\n• Full payment: 5% discount\n• Installments: 3 months\n• Education loan assistance available\n\nWant to know about a specific course fee?",
      options: ["📚 View All Courses", "📞 Talk to Counselor", "← Back to Main"]
    },
    "📅 Batch Schedule": {
      message: "📅 Upcoming Batch Schedule:\n\n• Weekday batches: Mon-Fri (2 hrs/day)\n• Weekend batches: Sat-Sun (4 hrs/day)\n• Evening batches: 6 PM - 8 PM IST\n\n✨ New batches start every 15 days!\nNext batch: Contact us for dates.",
      options: ["🎯 Register for Demo", "📞 Call for Dates", "← Back to Main"]
    },
    "📞 Contact Support": {
      message: "📞 How would you like to connect with us?",
      options: ["📱 Call Us", "📧 Email Us", "💬 WhatsApp", "← Back to Main"]
    },
    "📱 Call Us": {
      message: "📱 Call our admission counselors:\n\n🇺🇸 USA: +1 (888) 123-4567\n🇮🇳 India: +91 98765 43210\n\n⏰ Hours: Mon-Sat, 9 AM - 8 PM IST",
      options: ["🔄 Request Call Back", "← Back to Contact"]
    },
    "📧 Email Us": {
      message: "📧 Email us at:\n\n📨 info@learnthruus.com\n📨 admissions@learnthruus.com\n\nWe respond within 24 hours!",
      options: ["📤 Send Email Now", "← Back to Contact"]
    },
    "💬 WhatsApp": {
      message: "Chat with us instantly on WhatsApp!\nClick the button below to start a conversation with our team.",
      action: "whatsapp"
    },
    
    "💬 Talk to Human": {
      message: "👋 We'd love to connect! How would you prefer to reach us?",
      options: ["💬 WhatsApp Chat", "🔄 Request Call Back", "📧 Send Email", "← Back to Main"]
    },
    "💬 WhatsApp Chat": {
      message: "📱 Click below to chat with us on WhatsApp. Our team is ready to help!",
      action: "whatsapp"
    },
    "🔄 Request Call Back": {
      message: "Please fill in your details below and we'll call you back within 2 hours:",
      action: "callback-form"
    },
    "📤 Send Email Now": {
      message: "Opening your email client...\n\nOr manually email us at:\n📨 info@learnthruus.com",
      action: "email"
    },
    
    "✍️ Enroll Now": {
      message: "🎉 Great choice! To enroll:\n\n1. Contact our admissions team\n2. Complete the registration\n3. Choose your batch\n4. Make payment\n\nReady to start?",
      options: ["📞 Call to Enroll", "💬 WhatsApp Enroll", "← Back"]
    },
    "📥 Download Syllabus": {
      message: "📥 Please share your email to receive the detailed syllabus & course brochure.",
      action: "email-request"
    },
    "📥 Download Brochure": {
      message: "📥 Please share your email to receive the detailed brochure & curriculum.",
      action: "email-request"
    },
    "👨‍💼 Talk to Advisor": {
      message: "👨‍💼 Our academic advisors are ready to help! How would you like to connect?",
      options: ["💬 WhatsApp", "📞 Call Now", "📧 Email", "← Back"]
    },
    "📞 Call to Enroll": {
      message: "📞 Call us to enroll:\n\n🇺🇸 +1 (888) 123-4567\n🇮🇳 +91 98765 43210\n\nMention this chat for priority processing!",
      options: ["💬 WhatsApp Instead", "← Back"]
    },
    "💬 WhatsApp Enroll": {
      message: "Click below to enroll via WhatsApp. Our team will guide you through the process.",
      action: "whatsapp"
    },
    "📞 Call for Dates": {
      message: "📞 Call us for upcoming batch dates:\n\n🇺🇸 +1 (888) 123-4567\n🇮🇳 +91 98765 43210",
      options: ["💬 WhatsApp Instead", "← Back"]
    },
    "🎯 Register for Demo": {
      message: "🎯 Great! To register for a free demo class, please share:\n\n• Your Name\n• Phone Number\n• Course of Interest\n\nOur team will contact you with demo schedules.",
      options: ["💬 WhatsApp Register", "📞 Call to Register", "← Back"]
    },
    "📞 Talk to Counselor": {
      message: "📞 Our counselors are available:\n\n🇺🇸 +1 (888) 123-4567\n🇮🇳 +91 98765 43210\n\n⏰ Mon-Sat, 9 AM - 8 PM IST",
      options: ["💬 WhatsApp Instead", "← Back"]
    },
    "📚 View All Courses": {
      message: "Explore our complete range of medical coding programs:\n\n• Medical Coding (ICD-10, CPT, PCS)\n• CDI Training\n• Cancer Registry (ODS)\n• HCC/Risk Adjustment\n• Inpatient DRG\n• Auditing\n• Exam Preparation",
      options: ["🏥 Medical Coding", "📋 CDI Training", "🎗️ Cancer Registry", "← Back to Main"]
    },
    
    "← Back to Main": {
      message: "👋 Welcome back! How can I help you today?",
      options: ["📚 Courses & Programs", "💰 Fee Structure", "📅 Batch Schedule", "📞 Contact Support", "💬 Talk to Human"]
    },
    "← Back to Courses": {
      message: "We offer various medical coding and healthcare programs:",
      options: ["🏥 Medical Coding", "📋 CDI Training", "🎗️ Cancer Registry", "🔧 Specialized Training", "← Back to Main"]
    },
    "← Back to Medical Coding": {
      message: "Our Medical Coding programs include:",
      options: ["ICD-10-CM", "ICD-10-PCS", "CPT & E/M", "Exam Prep", "← Back to Courses"]
    },
    "← Back to Cancer Registry": {
      message: "Cancer Registry / ODS Training:\n• 80 hours training\n• NCRA exam prep\n• Cancer staging\n• ₹30,000 / $399",
      options: ["ODS Training", "Cancer Registry Management", "← Back to Courses"]
    },
    "← Back to Specialized Training": {
      message: "Specialized Training Programs:",
      options: ["HCC/Risk Adjustment", "Inpatient DRG Coding", "Auditing Training", "← Back to Courses"]
    },
    "← Back to Exam Prep": {
      message: "Exam Preparation Courses:\n• CCS Prep - ₹15,000 / $199\n• CPC Prep - ₹15,000 / $199\n• CIC Prep - ₹18,000 / $229",
      options: ["CCS Prep", "CPC Prep", "CIC Prep", "← Back to Medical Coding"]
    },
    "← Back to Contact": {
      message: "How would you like to connect with us?",
      options: ["📱 Call Us", "📧 Email Us", "💬 WhatsApp", "← Back to Main"]
    }
  },

  quickReplies: [
    "📚 Courses & Programs",
    "💰 Fee Structure",
    "📅 Batch Schedule",
    "📞 Contact Support"
  ]
};